import { IPublicClientApplication } from "@azure/msal-browser";
import ProjectTypeModel from "../Models/ProjectTypeModel";
import { apiLoginRequest } from "../Config";

export default class ProjectTypesService {

    msalInstance: IPublicClientApplication;

    constructor(msalInstance: IPublicClientApplication) {
        this.msalInstance = msalInstance;
    }

    public async getAll(): Promise<ProjectTypeModel[]> {

        const baseUrl = process.env.REACT_APP_API_URL;
        const accessToken = await this.acquireAccessToken();

        const records = await fetch(baseUrl + '/api/ProjectTypes', {
            method: 'get',
            headers: new Headers({
                'Authorization': 'Bearer ' + accessToken
            })
        }).then(function (response) {
            return response.json();
        });

        return records;
    }

    public async upsert(toUpdate: ProjectTypeModel[]) {
        const baseUrl = process.env.REACT_APP_API_URL;
        const accessToken = await this.acquireAccessToken();

        const records = await fetch(baseUrl + "/api/ProjectTypes", {
            method: "post",
            headers: new Headers({
                "Authorization": "Bearer " + accessToken
            }),
            body: JSON.stringify(toUpdate)
        }
        ).then(function (response) {
            return response.json();
        })
        return records;
    }

    private async acquireAccessToken() {
        const account = this.msalInstance.getActiveAccount();
        if (!account) {
            throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
        }

        const authResult = await this.msalInstance.acquireTokenSilent({
            ...apiLoginRequest,
            account: account
        });

        return authResult.accessToken;
    };
}